export default "__VITE_ASSET__a9bff024__"